







import { projectAuth } from '@/firebase/config'
import { Component, Vue } from 'vue-property-decorator'
import Sidebar from '@/components/Sidebar.vue'

@Component({
  components: {
    Sidebar,
  },
})
export default class Home extends Vue {
  currentUser: any = null

  mounted() {
    this.currentUser = projectAuth.currentUser
  }

  created() {
    projectAuth.onAuthStateChanged(async (user: any) => {
      if (user) {
        this.currentUser = user
      } else {
        this.currentUser = null
      }
    })
  }

  async logout() {
    projectAuth.signOut().then(() => {
      this.$router.push({ name: 'login' })
    })
  }
}
